import React, { useState, useRef, useEffect } from "react";

// Renders text clamped to `maxLines` lines that reflow with the container
// width, so a wider column reveals more of the text (instead of a fixed
// character cut). A "More+" link (opening the full-response modal) is shown
// ONLY when the content actually overflows the clamp, and overflow is
// re-measured whenever the element resizes — e.g. when a column is dragged
// wider or narrower.
export default function SeeMoreWrapper({ text, limit = 50, maxLines = 2, openModal }) {
  const clampRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = clampRef.current;
    if (!el) {
      return undefined;
    }
    const measure = () => {
      setIsOverflowing(el.scrollHeight - el.clientHeight > 1);
    };
    measure();
    // Re-measure on width change (e.g. column resize) so "More+" appears or
    // disappears as the reflowed text starts/stops overflowing the clamp.
    if (typeof ResizeObserver === "undefined") {
      return undefined;
    }
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => {
      observer.disconnect();
    };
  }, [text, maxLines]);

  if (!text) {
    return <div />;
  }

  return (
    <div>
      <div
        ref={clampRef}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: maxLines,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          whiteSpace: "normal",
          wordBreak: "break-word",
        }}
      >
        {text}
      </div>
      {isOverflowing ? (
        <span
          className="text-info cursor-pointer font-11px"
          onClick={() => {
            if (openModal) {
              openModal();
            }
          }}
        >
          More+
        </span>
      ) : null}
    </div>
  );
}
